import React from 'react';

import Icon from 'core/modules/atoms/Icon';

import './_empty-state.scss';

type EmptyStateVariant = 'success' | 'warning' | 'muted' | 'info' | 'error';

type EmptyStateProps = {
  description: string;
  iconType?: string;
  iconVariant?: EmptyStateVariant;
  title: string;
};

function EmptyState({ description, iconType, iconVariant, title }: Readonly<EmptyStateProps>): JSX.Element {
  const hasIcon = !!iconType && !!iconVariant;

  return (
    <div className="empty-state">
      {hasIcon && (
        <div className={`empty-state__icon empty-state__icon--${iconVariant}`}>
          <Icon size="default" type={iconType} />
        </div>
      )}
      <h3 className="empty-state__title">{title}</h3>
      <p className="empty-state__description">{description}</p>
    </div>
  );
}

export default EmptyState;
